import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import './DropdownItem.scss';

type OnClickCallback = (e) => void;

export type DropDownItemStyles = 'highlighted' | 'main' | 'divided-arrow' | 'divided';

interface DropdownItemProps {
  // Href link of the item
  href?: string;
  // Text shown in dropdown ite,
  text: string;
  // Pass an element which represents dropdown item icon
  icon?: JSX.Element;
  // Active status (highlighted)
  active?: boolean;
  dotted?: boolean;
  // Disabled state
  disabled?: boolean;
  onClick?: OnClickCallback;
  dataTracking?: string;
  isReactRoute?: boolean;
  isButton?: boolean;
  isDiv?: boolean;
  style?: DropDownItemStyles;
}

const DropdownItem: React.FC<DropdownItemProps> = props => {
  const {
    text,
    icon,
    active,
    disabled,
    dotted,
    onClick,
    href,
    dataTracking,
    isReactRoute,
    isButton,
    isDiv,
    style
  } = props;

  const styles = classNames(
    { 'user-dropdown-item__link': true,
    'user-dropdown-item__link--dotted': dotted,
    active: active && !disabled,
    disabled
  });

  const commonProps = {
    href: href || '#',
    onClick: onClick ? onClick : () => true,
    'data-tracking': dataTracking
  };

  const ChildComponent = (<>
    {icon &&
      <span styleName={classNames('user-dropdown-item__icon', {
        'user-dropdown-item__icon--highlight': style === 'main' || style === 'highlighted'
      })}>
        {icon}
      </span>
    }
    <span styleName={classNames('user-dropdown-item__title', {
      'user-dropdown-item__title--blue': style === 'divided'
    })}>
      {text}
    </span>
    { (style === 'highlighted' || style === 'divided-arrow') &&
      <div styleName="user-dropdown-item__chevron">
        <div className="dashicon dashicon-chevron-right" />
      </div>
    }
  </>);

  const ControlComponent = () => {
    switch (true) {
      case isButton:
        return <button type="button" styleName={styles} {...commonProps}>{ChildComponent}</button>;
      case isDiv:
        return <span styleName={styles} {...commonProps}>{ChildComponent}</span>;
      default:
        return isReactRoute
          ? <Link styleName={styles} to={href} {...commonProps}>{ChildComponent}</Link>
          : <a styleName={styles} {...commonProps}>{ChildComponent}</a>;
    }
  };

  return (
    <div styleName={classNames('user-dropdown-item', {
      'user-dropdown-item--main': style === 'main',
      'user-dropdown-item--highlighted': style === 'highlighted',
      'user-dropdown-item--divided': style === 'divided' || style === 'divided-arrow'
    })}>
      <ControlComponent />
    </div>
  );
};

export default DropdownItem;
